import { observable } from 'rewire-core';

export type BatchMode = 'Create' | 'Summary' | 'Adjustments';

interface IBatchMode {
  mode: BatchMode;
}

class BatchModeModel {
  state: IBatchMode;

  constructor() {
    this.state = observable({
      mode: 'Summary',
    });
  }

  get mode(): BatchMode {
    return this.state.mode;
  }

  set mode(value: BatchMode) {
    this.state.mode = value;
  }

  isMode(mode: BatchMode): boolean {
    return batchModeModel.mode === mode;
  }
}

const batchModeModel = new BatchModeModel();
export default batchModeModel;
